import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../common/utilities/ImgUrl';
import { AddNewPermissionStyles } from './style/AddNewPermissionStyle';

export interface AddNewPermissionProps {
  containerStyle: AddNewPermissionStyles.AddNewPermissionContainerStyleArgs;
  disabled: boolean;
  onClick: () => void;
}

export class AddNewPermission extends React.PureComponent<AddNewPermissionProps, {}>{
  public static readonly BUTTON_ID = 'add-new-permission-button';

  private getButtonContent = (): JSX.Element => {
    const imgSrc: string = this.props.disabled ? imgPath('permission_rule_add_disabled.svg') : imgPath('permission_rule_add.svg');
    return (
      <span className={ AddNewPermissionStyles.ButtonContent }>
        <img
          aria-hidden={ true }
          src={ imgSrc }
        />
        { Messages.permissionRuleAdd() }
      </span>
    );
  }

  public render() {
    const containerClassName = AddNewPermissionStyles.memoizedButtonContainer(this.props.containerStyle);
    return (
      <div className={ containerClassName }>
        <ButtonWidget
          buttonType={ ButtonType.Outline }
          disabled={ this.props.disabled }
          getContent={ this.getButtonContent }
          handleClick={ this.props.onClick }
          testId={ AddNewPermission.BUTTON_ID }
        />
      </div>
    );
  }
}
